function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.50131 0.885728C7.54345 0.875956 5.31241 5.28693 3.67474 7.65975C2.50822 9.74433 -0.370977 13.3785 0.40108 16.2855C1.29282 19.3097 4.63644 20.0801 6.41571 17.7545C7.24929 16.6633 7.42714 16.7936 7.40438 18.0126C7.38415 20.3431 6.10385 21.6687 5.16659 22.8128L11.279 22.856C9.98352 21.3528 8.81869 20.1037 8.68468 18.0631C8.68889 17.2952 8.92489 16.7374 9.48371 17.5664C10.1133 18.1592 10.6485 19.2495 12.3688 18.9441C14.1531 18.6371 15.7099 16.3995 15.3525 14.2294C14.8729 11.7092 13.242 9.23214 11.6035 7.10767C10.2347 5.33415 7.45074 0.974485 7.50131 0.885728Z",
  fill: "currentColor"
});

function SvgSuitSpade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitSpade);
export default __webpack_public_path__ + "static/media/suitSpade.313e212c.svg";
export { ForwardRef as ReactComponent };